import React, { PureComponent } from "react";
import { extractExtension, extractFileNameAndExtension } from "../../utils";
import MyPATUploadPreviewItem from "./MyPATUploadPreviewItem";
import {
  WithStyles,
  withStyles,
  createStyles,
  Theme,
  Grid,
} from "@material-ui/core";
import { CloseOutlined as CloseIcon } from "@material-ui/icons";
import { Attachment } from "./MyPATUploader";
import classNames from "classnames";

const styles = (theme: Theme) =>
  createStyles({
    itemContainer: {
      position: 'relative',
      border: '1px solid #d8d8d8',
      borderRadius: 4,
      padding: 12,
    },
    closeIcon: {
      top:-8,
      right:-8,
      cursor: "pointer",
      position: "absolute",
      background: "rgb(255 255 255)",
      border: "1px solid rgb(102 102 102)",
      borderRadius: "50%",
    },
    clickable: {
      cursor: "pointer",
    },
    image: {
      width: "100%",
    },
    pdfView: {
      width: "100%",
      zIndex: 100,
      borderRadius: "4px",
      padding: "0 !important",
    },
    closeEdit:{
      top: "19px",
      right: "10px",
      cursor: "pointer",
      position: "absolute",
      backgroundColor: "transparent",
      width: "25px",
      height: "25px",
      borderRadius: "0",
      color: "#000",
      border: "none"
    },
    pdfHeader:{
      zIndex: 90,
      padding: "6px 12px 0px !important",
      paddingTop: "0 !important",
      position: 'absolute',
      top: 12,      
    },
    paddingMD:{
      padding: '6px 20px 4px',
    },
    itemContainerEdit:{
      position: 'relative',
      background: '#fafafa',
      border: '1px solid #E1E1E1',
      borderRadius: '4px 4px 0 0',
      '& div':{
        '& h6':{
          color: '#333',
          fontSize: '16px',
          fontWeight: 400,
        }
      }
    }
  });

export interface PreviewItem {
  url: string;
  extension: string;
  fileName: string;
  size?: number; // in Bytes
}

interface Props extends WithStyles<typeof styles> {
  list: PreviewItem[];
  readOnly?: boolean;
  onItemRemove?: (index: number) => void;
  itemsDownloadable?: boolean;
  renderAttachmentItem?: (attachmentItem: PreviewItem) => any;
  showPdfView?: boolean;
  pdfPageData?: any;
  pdfType?: any;
}

class MyPATUploadPreview extends PureComponent<Props> {
  handleItemClick = (url: string) => {
    window.open(url, "_blank");
  };
  renderAttachmentItem = (item: PreviewItem) => {
    const { url, fileName, extension } = item;
    const { itemsDownloadable, classes, showPdfView, pdfPageData, pdfType } = this.props;
    switch (extension) {
      case "jpg":
      case "jpeg":
      case "png": {
        return (
          <img
            src={url}
            alt="attachment"
            onClick={() => itemsDownloadable && this.handleItemClick(url)}
            className={classNames(
              classes.image,
              itemsDownloadable && classes.clickable
            )}
          />
        );
      }
      default: {
        return (
          <MyPATUploadPreviewItem
            extension={extension}
            fileName={fileName}
            url={url}
            itemsDownloadable={itemsDownloadable}
            showPdfView={showPdfView}
            pdfPageData={pdfPageData}
            pdfType={pdfType}
          />
        );
      }
    }
  };
  render() {
    const {
      list,
      classes,
      readOnly = true,
      onItemRemove = () => {},
      renderAttachmentItem,
      showPdfView
    } = this.props;
    return (
      <Grid container wrap="wrap" spacing={24} alignItems="flex-start" className={[classes.paddingMD,showPdfView ? classes.pdfHeader : ""].join(' ')} >
        {list.map((listItem, i) => {
          if(renderAttachmentItem) {
            return renderAttachmentItem(listItem)
          }
          return (
            <Grid item xs={showPdfView ? 12 : 6} className={showPdfView ? classes.pdfView : ""}>
              <Grid className={[classes.itemContainer, showPdfView ? classes.itemContainerEdit : ""].join(' ')}>
              {!readOnly && (
                <CloseIcon
                  fontSize="small"
                  className={[classes.closeIcon,showPdfView ? classes.closeEdit : ""].join(' ')}
                  onClick={() => onItemRemove(i)}
                />
              )}
              {this.renderAttachmentItem(listItem)}
            </Grid>
            </Grid>
          );
        })}
      </Grid>
    );
  }
}

function convertFileOrUrlToPreviewItem(file: Attachment): PreviewItem {
  if (typeof file === "string") {
    let fileName = "attachment";
    try {
      const splittedUrl = file.split("/");
      const fileNameWithIdentifiers = splittedUrl[splittedUrl.length - 1];
      const [module, id, ...splittedFileName] = fileNameWithIdentifiers.split(
        "_"
      );
      const fileNameWithExtension = splittedFileName.join("_");
      const { fileName: name } = extractFileNameAndExtension(
        fileNameWithExtension
      );
      fileName = name;
    } catch (error) {
      console.log(error);
    }

    return {
      url: file,
      extension: extractExtension(file),
      fileName,
    };
  } else {
    const previewUrl = URL.createObjectURL(file);
    const { fileName, extension } = extractFileNameAndExtension(file.name);
    return {
      url: previewUrl,
      fileName,
      extension,
      size: file.size
    };
  }
}

export { convertFileOrUrlToPreviewItem };

export default withStyles(styles)(MyPATUploadPreview);